import { useState } from 'react';
import FileUpload from '../FileUploader/FileUploader';

export interface DynamicFileUploadProps {
  label?: string;
  updateFilesCb: (files: File[]) => void;
  maxFileSizeInBytes?: number;
  accept?: string;
  multiple?: boolean;
  buttonText?: string;
}

interface FileUploadInstance {
  id: string;
  files: File[];
}

const DynamicFileUpload = ({
  label = 'Otro archivo (opcional)',
  updateFilesCb,
  maxFileSizeInBytes = 1000000,
  accept = 'image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls',
  multiple = true,
  buttonText = 'Agregar otro archivo'
}: DynamicFileUploadProps) => {
  const [fileUploads, setFileUploads] = useState<FileUploadInstance[]>([
    { id: `file-upload-${Date.now()}`, files: [] }
  ]);

  const addFileUpload = () => {
    const newId = `file-upload-${Date.now()}-${Math.random()}`;
    setFileUploads((prev) => [...prev, { id: newId, files: [] }]);
  };

  const updateFilesForInstance = (id: string, files: File[]) => {
    setFileUploads((prev) => {
      const updatedUploads = prev.map((upload) =>
        upload.id === id ? { ...upload, files } : upload
      );

      // Consolidar todos los archivos de todas las instancias
      const allFiles = updatedUploads.flatMap((upload) => upload.files);
      updateFilesCb(allFiles);

      return updatedUploads;
    });
  };

  const removeFileUpload = (id: string) => {
    setFileUploads((prev) => {
      const updatedUploads = prev.filter((upload) => upload.id !== id);

      // Actualizar archivos consolidados después de eliminar
      const allFiles = updatedUploads.flatMap((upload) => upload.files);
      updateFilesCb(allFiles);

      return updatedUploads;
    });
  };

  return (
    <div className="w-full">
      {fileUploads.map((upload, index) => (
        <div key={upload.id} className="mb-4 relative">
          <FileUpload
            label={index === 0 ? label : `${label} ${index + 1}`}
            updateFilesCb={(files) => updateFilesForInstance(upload.id, files)}
            maxFileSizeInBytes={maxFileSizeInBytes}
            accept={accept}
            multiple={multiple}
          />
          {fileUploads.length > 1 && (
            <button
              type="button"
              onClick={() => removeFileUpload(upload.id)}
              className="mt-2 text-red-500 text-sm hover:text-red-700"
            >
              Eliminar este archivo
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={addFileUpload}
        className="mt-2 text-blue-500 hover:text-blue-700 font-medium"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default DynamicFileUpload;
